export default __webpack_public_path__ + "images/post-banner-ph.jpg";